import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    id: 'notificationsCenter.uploads.removeUploadDialog.description',
    defaultMessage:
      'Are you sure you want to remove this upload? This will remove upload from list of notification.',
  },
  failed: {
    id: 'notificationsCenter.uploads.failed',
    defaultMessage: 'Upload failed — try again',
  },
  noContent: {
    id: 'notificationsCenter.uploads.noContent',
    defaultMessage: 'No uploads',
  },
  title: {
    id: 'notificationsCenter.uploads.removeUploadDialog.title',
    defaultMessage: 'Remove upload',
  },
});

export default messages;
